export default __webpack_public_path__ + "static/media/SD_nandi_banner.2ca24cbd.jpg";